export default __webpack_public_path__ + "ddc012b.woff2";